import { useState } from "react";
import InputField from "../Atoms/InputField";
import styles from "../../Styles/LogPrompt.module.css";

const LogPrompt = ({ isRegister, inputs }) => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");

  const userHandler = (value) => {
    setUserName(value);
    inputs({
      email: email,
      userName: value,
      password: password,
      passwordCheck: passwordCheck,
    });
  };
  const emailHandler = (value) => {
    setEmail(value);
    inputs({
      email: value,
      userName: userName,
      password: password,
      passwordCheck: passwordCheck,
    });
  };
  const passwordHandler = (value) => {
    setPassword(value);
    inputs({
      email: email,
      userName: userName,
      password: value,
      passwordCheck: passwordCheck,
    });
  };
  const passwordCheckHandler = (value) => {
    setPasswordCheck(value);
    inputs({
      email: email,
      userName: userName,
      password: password,
      passwordCheck: value,
    });
  };

  return (
    <div>
      {isRegister && (
        <div className={styles.container}>
          <InputField
            label={"Enter Your User Name"}
            input={userHandler}
            isLog={true}
            type={"userName"}
          />
        </div>
      )}
      <div className={styles.container}>
        <InputField
          label={"Enter Your Email"}
          input={emailHandler}
          isLog={true}
          type={"email"}
        />
      </div>
      <div className={styles.container}>
        <InputField
          label={"Enter Your Password"}
          input={passwordHandler}
          isLog={true}
          type={"password"}
        />
      </div>
      {isRegister && (
        <div className={styles.container}>
          <InputField
            label={"Re-Enter Your Password"}
            input={passwordCheckHandler}
            isLog={true}
            type={"password"}
          />
        </div>
      )}
    </div>
  );
};

export default LogPrompt;
